export const selector = 'dbABlur';

/* @ngInject */
export default function BlurDirective($parse) {
    return {
        restrict: 'A',

        link(scope, element, attrs) {
            let setter = $parse(attrs[selector]);

            setter(scope, {
                callback: blurHandler
            });

            function blurHandler() {
                setTimeout(() => element[0].blur(), 0);
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/blur/blur.directive.js